import { inject, Signal } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PurchaseStore } from '@features/purchase/store/purchase.store';
import { UserStore } from '@shared/stores/user.store';

export const purchaseMenuGuard: CanActivateFn = async (route) => {

  const userStore = inject(UserStore);
  const router = inject(Router);
  const qp = route.queryParams;
  const purchaseStore = inject(PurchaseStore);

  const isPurchaseMenuEnabled: boolean = userStore.user().features.PurchaseMenu;
  const isLoggedIn$: Signal<boolean> = userStore.isAuthenticated;

  // Allow access to purchase confirmation page if product is nmfc-book or productType is NmfcBook
  if (qp['product'] === 'nmfc-book' || purchaseStore.order.purchaseInformation.productType() === 4) {
    return true;
  }

  if (!isPurchaseMenuEnabled && isLoggedIn$()) {
    router.navigate(['/home']);
    return false;
  }

  return isPurchaseMenuEnabled || !isLoggedIn$();
}


